"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _pickers = require("@material-ui/pickers");

var _core = require("@material-ui/core");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _styles = require("@material-ui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppTheme = _interopRequireDefault(require("../../../../AppTheme"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var materialTheme = (0, _core.createMuiTheme)({
  overrides: {
    MuiPickersBasePicker: {
      pickerView: {
        minWidth: 280
      },
      pickerViewLandscape: {
        padding: 0
      }
    },
    MuiTypography: {
      body1: {
        fontSize: _AppTheme.default.typography.body2.fontSize,
        fontWeight: 700,
        fontFamily: "Vodafone"
      },
      body2: {
        fontSize: _AppTheme.default.typography.caption.fontSize,
        fontFamily: "Vodafone"
      }
    },
    MuiPickersStaticWrapper: {
      staticWrapperRoot: {
        backgroundColor: "none",
        minWidth: undefined
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        padding: _AppTheme.default.spacing(0, 0.5)
      },
      iconButton: {
        backgroundColor: "transparent",
        color: _AppTheme.default.palette.text.primary,
        padding: 8,
        width: 32,
        height: 32,
        "&:hover": {
          backgroundColor: (0, _core.fade)(_AppTheme.default.palette.secondary.main, 0.30),
          color: _AppTheme.default.palette.text.primary
        },
        "&.Mui-disabled": {
          color: _AppTheme.default.palette.grey[500]
        }
      },
      dayLabel: {
        color: _AppTheme.default.palette.text.secondary,
        fontSize: _AppTheme.default.typography.caption.fontSize,
        fontFamily: "Vodafone",
        width: 32,
        margin: _AppTheme.default.spacing(0, 0.5)
      }
    },
    MuiPickersDay: {
      day: {
        fontSize: _AppTheme.default.typography.caption.fontSize,
        color: _AppTheme.default.palette.text.primary,
        margin: 4,
        width: 32,
        height: 32,
        "&:hover": {
          backgroundColor: (0, _core.fade)(_AppTheme.default.palette.secondary.main, 0.3),
          color: _AppTheme.default.palette.text.primary
        }
      },
      current: {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: _AppTheme.default.palette.secondary.main,
        color: _AppTheme.default.palette.text.primary
      },
      daySelected: {
        backgroundColor: _AppTheme.default.palette.secondary.main,
        fontWeight: 700,
        "&:hover": {
          backgroundColor: _AppTheme.default.palette.secondary.main,
          color: _AppTheme.default.palette.common.white
        }
      },
      dayDisabled: {
        color: _AppTheme.default.palette.text.disabled
      }
    }
  }
});

var LocalizedUtils = /*#__PURE__*/function (_DateFnsUtils) {
  _inherits(LocalizedUtils, _DateFnsUtils);

  var _super = _createSuper(LocalizedUtils);

  function LocalizedUtils() {
    _classCallCheck(this, LocalizedUtils);

    return _super.apply(this, arguments);
  }

  _createClass(LocalizedUtils, [{
    key: "getWeekdays",
    value: function getWeekdays() {
      return ["M", "T", "W", "T", "F", "S", "S"];
    }
  }]);

  return LocalizedUtils;
}(_dateFns.default);
/**
 * ** The calendar component is designed to sit on a white background. This can either be the white background of the page, or a white card. **
 *
 * There are 2 limits: DisableFuture, DisableFuture
 */


var PickerCalendar = function PickerCalendar(_ref) {
  var disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      value = _ref.value,
      onChange = _ref.onChange;

  var _useState = (0, _react.useState)(new Date()),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      changeDate = _useState2[1];

  if (value) {
    changeDate(value); // onChange(value);
  }

  ;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: materialTheme
  }, /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: LocalizedUtils
  }, /*#__PURE__*/_react.default.createElement(_pickers.DatePicker, {
    autoOk: true,
    disablePast: disablePast,
    disableFuture: disableFuture,
    orientation: "landscape",
    variant: "static",
    disableToolbar: true,
    openTo: "date",
    value: date,
    onChange: changeDate,
    leftArrowIcon: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      icon: "ic_chevron__left",
      size: "small",
      color: "grey"
    }),
    rightArrowIcon: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      icon: "ic_chevron__right",
      size: "small",
      color: "grey"
    })
  })));
};

PickerCalendar.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  disableFuture: _propTypes.default.bool,
  disablePast: _propTypes.default.bool
};
PickerCalendar.defaultProps = {
  value: null,
  disableFuture: false,
  disablePast: false
};
var _default = PickerCalendar;
exports.default = _default;